import React from 'react';
import { Layout } from 'tea-component';
import { TipsMapType } from '@op/components/BubbleCommon';
import CommonBodyTips from '../CommonBodyTips';
import CardLoading from '@op/components/CardLoading';

type TElementType = JSX.Element | Array<JSX.Element>;
type TElementFunc = () => JSX.Element | Array<JSX.Element>;
const { Content } = Layout;
export default function MarketContentBody({
  children,
  contentHeard,
  horseRaceLampTips,
  loading = false,
  filterSlot = null,
  ...otherProps
}: {
  children: TElementType | TElementFunc;
  contentHeard?: JSX.Element;
  horseRaceLampTips?: TipsMapType | Array<TipsMapType>;
  loading?: boolean;
  filterSlot?: TElementType | null;
  [key: string]: any;
}) {
  const childrenElement =
    typeof children === 'function' ? children() : children; 
  return (
    <>
      {contentHeard}
      <Content.Body {...otherProps} full>
        <CommonBodyTips horseRaceLampTips={horseRaceLampTips}></CommonBodyTips>
        {filterSlot}
        <CardLoading loading={loading}>{childrenElement}</CardLoading>
      </Content.Body>
    </>
  );
}
